/* -------------------------------------------------------------------------- */
/*                                    操作权限                                 */
/* -------------------------------------------------------------------------- */

// 分配客户经理、批量分配客户经理、划转、批量划转
export const ASSIGN_MANAGER_ACTION = '83503d12-e411-4fb3-88e7-6ef872e8f463'
